export function sslStatus (prop, t$) {
  let objSsl = ''
  if (prop.security_wait) {
    objSsl = {
      icons: '$security-shield-lock-filled',
      color: 'gray',
      status: true,
      security_wait: true,
      value: 'Ativando Certificado SSL'
    }
  } else {
    const icons = {
      true: '$security-shield-lock-filled',
      false: '$security-shield-lock-filled'
    }

    const color = {
      true: 'success',
      false: '#F43339'
    }

    const status = {
      true: true,
      false: false
    }
    objSsl = {
      value: t$[prop.status],
      icons: icons[prop.status],
      color: color[prop.status],
      status: status[prop.status]
    }
  }

  return objSsl
}
